// extracted by mini-css-extract-plugin
export var emptyState = "_6x-d";
export var statCard = "_6x-c";
export var table = "_6x-0";
export var tableCell = "_6x-4";
export var tableCellClickable = "_6x-5 _6x-4";
export var tableCellDefault = "_6x-6 _6x-4";
export var tableCellEmpty = "_6x-8";
export var tableCellWithValue = "_6x-7";
export var tableContainer = "_6x-e";
export var tableHeaderWeight = "_6x-1";
export var tableHeaderZone = "_6x-2";
export var tableRowHeader = "_6x-3";
export var viewModeButton = "_6x-9";
export var viewModeButtonActive = "_6x-a _6x-9";
export var viewModeButtonInactive = "_6x-b _6x-9";